import { useNavigate } from "react-router-dom";
import { ChevronLeft, BookOpen } from "lucide-react";
import { LORE_ENTRIES } from "@/lib/lore";

// The lore/history nook — a browsable page grounding the practice in its real,
// cross-cultural roots. Reachable from the Portal intro and the practitioner hub.
export default function Lore() {
  const navigate = useNavigate();

  return (
    <div className="soma-grain relative min-h-screen bg-soma-surface px-5 py-10">
      <div className="mx-auto max-w-2xl">
        <button
          onClick={() => navigate(-1)}
          data-testid="lore-back"
          className="mb-6 flex items-center gap-2 text-sm text-soma-muted hover:text-soma-on"
        >
          <ChevronLeft size={18} /> Back
        </button>

        <div className="mb-10">
          <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.35em] text-soma-brand">
            <BookOpen size={13} /> the old art
          </p>
          <h1 className="mt-2 font-display text-5xl italic leading-tight text-soma-on md:text-6xl">
            Wander the lore.
          </h1>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-soma-on2">
            Palmistry is old, and shared by many hands. A few notes on where it comes from, how it
            lives, and how to meet it with respect.
          </p>
        </div>

        <div className="space-y-4">
          {LORE_ENTRIES.map((e) => (
            <div
              key={e.key}
              data-testid={`lore-entry-${e.key}`}
              className="rounded-2xl border border-soma-border bg-soma-surface2 p-6"
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-soma-brand">{e.kicker}</p>
              <h2 className="mt-1.5 font-display text-2xl text-soma-on">{e.title}</h2>
              <p className="mt-2 leading-relaxed text-soma-on2">{e.body}</p>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center font-mono text-[10px] uppercase tracking-wide text-soma-muted">
          A reflection, never a prediction.
        </p>
      </div>
    </div>
  );
}
